import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import { FC, useCallback, useEffect, useState } from "react";
import { Container } from "~/components/Container";
import Experience from "~/components/HomeSections/Experience";
import Layout from "~/components/Layout";
import NewsletterWidget from "~/components/NewsletterWidget";

import Hero from "~/components/ResourceSections/Hero";
import ResourceListSection from "~/components/ResourceSections/ResourceListSection";
import SignUpWidget from "~/components/SignUpWidget";
import { resourceNameByType } from "~/constants/data";
import { Category, ResourceApi, ResourceTypes } from "~/services/resource";

interface ResourceByTypeProps {
  type: ResourceTypes;
  categories: Category[];
}

const ResourceByType: FC<ResourceByTypeProps> = ({ type, categories }) => {
  const renderContent = useCallback(() => {
    switch (type) {
      case ResourceTypes.BLOGS: {
        return (
          <ResourceListSection
            id="blogs"
            type={ResourceTypes.BLOGS}
            categories={categories}
            variant="secondary"
            totalItemRenderInRow={3}
            isLoadingMore
            pageSize={15}
            containerClassName="px-0"
          />
        );
      }
      case ResourceTypes.CASE_STUDY: {
        return (
          <ResourceListSection
            id="case-study"
            type={ResourceTypes.CASE_STUDY}
            variant="secondary"
            totalItemRenderInRow={3}
            isLoadingMore
            pageSize={15}
            containerClassName="px-0"
          />
        );
      }
      case ResourceTypes.PRODUCT_VIDEOS: {
        return (
          <ResourceListSection
            id="product-videos"
            type={ResourceTypes.PRODUCT_VIDEOS}
            variant="secondary"
            totalItemRenderInRow={3}
            isLoadingMore
            pageSize={15}
            containerClassName="px-0"
          />
        );
      }
    }
  }, [categories]);

  return (
    <Layout>
      <main className="bg-white">
        <div className="relative">
          <Hero title={resourceNameByType[type]} />

          <Container className="flex flex-col gap-x-12 gap-y-7 mt-9 md:flex-row mb-[100px]">
            <div className="flex-1">{renderContent()}</div>

            <div className="sticky flex flex-col gap-y-6 top-24 h-max md:max-w-[267px] py-8">
              <SignUpWidget />
              <NewsletterWidget />
            </div>
          </Container>
        </div>

        <Experience />
      </main>
    </Layout>
  );
};
export default ResourceByType;

export const getServerSideProps: GetServerSideProps = async ({
  params: _params,
  locale,
}) => {
  const type = _params?.type as ResourceTypes;
  const categories = await ResourceApi.getCategories();

  return {
    props: {
      type,
      categories,
      ...(await serverSideTranslations(locale || "en", ["common"])),
    },
  };
};
